import {Strings} from '../Strings';

import {HttpSvcFactory} from '../services/HttpSvc';
import {AdSvc} from '../services/AdSvc';
import {OAuthCallbackSvc} from '../services/OAuthCallbackSvc';
import {Utils} from '../underscore-extensions';
import LightLandings from '../LightLandingPages';
import MediumLandings from '../MediumLandingPages';
import {
    animatronSettings,
    animatronTutorial,
    animatronEdu,
    animatronUserPage,
    animatronAbout,
    animatronCompany,
    animatronContractors,
    animatronPricing,
    animatronSignup,
    animatronActivate,
    animatronRecovery,
    animatronRecoveryReset,
    animatronPrivacy,
    animatronTermsServices,
    animatronProjectAnalytics,
    animatronProject,
    animatronProjects,
    animatronSearchPage,
    animatronBannerBottom,
    animatronExplainerBottom,
    animatronEmotions,
    animatronLandingNewBottom,
    animatronContest,
    animatronPublish,
    animatronSpecialUpgrade,
    animatronMediumLanding,
    waveMain,
    animatronComparisonBottom,
    waveMyProjects,
    wavePricing,
    mainLanding,
    waveUserPage,
    waveLandingSMMW,
    waveLandingAds
} from '../lazy_modules'; //TODO use `import * as modules from 'lazy_modules'`;

import {
    setWrapper,
    setTitle,
    loadModule,
    redirect,
    redirectResolve,
    nullToEmptyString,
    redirectForLogin,
    extendState, trackVisit
} from './RouteUtils';
import {AuthenticationSvc} from '../services/AuthenticationSvc';
import {TypeformSvc} from '../settings/services/TypeformSvc';
import {AnimatronProjectsFactory} from '../services/AnimatronProjectsSvc';
import {LocalStorageSvc} from '../services/LocalStorageSvc';
import {TranslateSvc} from '../services/TranslateSvc';

//TODO remove duplicate check anonymous
class Routes {
    constructor($stateProvider: ng.ui.IStateProvider,
                $urlRouterProvider: ng.ui.IUrlRouterProvider,
                $locationProvider: ng.ILocationProvider,
                $urlMatcherFactoryProvider: ng.ui.IUrlMatcherFactory) {
        $urlMatcherFactoryProvider.caseInsensitive(true);
        $urlRouterProvider.rule(($injector: ng.auto.IInjectorService, $location: ng.ILocationService): any => {
            const path = $location.url();
            // check to see if the path has a trailing slash
            if ('/' === path[path.length - 1]) {
                return path.replace(/\/$/, '');
            }

            return false;
        });
        extendState($stateProvider);

        const tutorialResolve = _.extend(loadModule(animatronTutorial), setWrapper('wrapper-tutorial wrapper-long-head'));

        const projectsModules = loadModule(animatronProjects);

        const getLandingParams = () => ({
            url: '/studio/landing?signup',
            template: `<landing-page></landing-page>`,
            resolve: _.extend(
                loadModule(animatronLandingNewBottom),
                setWrapper('wrapper-landing-common wrapper-landing-new'),
                setTitle())
        });

        const SMMWParams = ['utm_source', 'utm_medium', 'utm_campaign'].join('&');

        const SMMWPages: anm.WaveSMMWLandings[] = ['Image', 'Video'];

        $locationProvider.html5Mode(true).hashPrefix('!');
        $urlRouterProvider.otherwise(($injector: ng.auto.IInjectorService) => {
            $injector.get<ng.ui.IStateService>('$state').go('404');
        });
        $urlRouterProvider.when('', '/');
        $urlRouterProvider.when('/studio', '/studio/landing');

        (function setupStates() {
            $stateProvider
                .state('wave-combine-media', {
                    url: '/wave/combine-media',
                    template: '<wave-landing-ads />',
                    resolve: _.extend(
                        setTitle(''),
                        loadModule(waveLandingAds()),
                        setWrapper('wrapper-landing-WAVE-ads'),
                        trackVisit('Landing', {Name: 'Combine Media'})
                    )
                })
                .state('wave', {
                    url: `/wave?${SMMWParams}`,
                    onEnter($location: ng.ILocationService,
                            $stateParams: ng.ui.IStateParamsService) {
                        const {utm_source, utm_medium, utm_campaign} = $stateParams;

                        const isSMMW = utm_source === 'SMExaminer'
                            && utm_medium === 'IndustryReport'
                            && utm_campaign === 'SMEad';

                        const SMMWPage = SMMWPages[_.random(1)];
                        const url      = isSMMW ? `/wave/SMExaminerReport${SMMWPage}` : '/wave/landing';
                        $location.path(url).replace();
                    }
                })
                .state('wave-user', {
                    url: '/wave/users/:username',
                    template: '<wave-user-page></wave-user-page>',
                    resolve: _.extend(
                        loadModule(waveUserPage),
                        setWrapper('wave-user-page-wrapper wrapper-wave-projects'),
                        setTitle(),
                        redirectResolve(() => !options.user.rolez.Admin, '/wave/landing')
                    )
                })
                .state('studio-user', {
                    url: '/studio/users/:username?startFollowing&customize&bgColor&page&removed',
                    params: {user: null},
                    template: '<user-page></user-page>',
                    resolve: _.extend(
                        loadModule(options.enableContests ? animatronContest : animatronUserPage),
                        setWrapper('userpage-wrapper'),
                        setTitle()
                    )
                })
                .state('studio-following', {
                    url: '/studio/users/:username/following',
                    params: {user: null},
                    template: '<followers-page></followers-page>',
                    resolve: _.extend(
                        loadModule(animatronUserPage),
                        setWrapper('follow-wrapper'),
                        setTitle()
                    )
                })
                .state('studio-followers', {
                    url: '/studio/users/:username/followers',
                    params: {user: null},
                    template: '<followers-page></followers-page>',
                    resolve: _.extend(
                        loadModule(
                            animatronUserPage),
                        setWrapper('follow-wrapper'),
                        setTitle()
                    )
                })
                .state('home', {
                    url: '/home?login&isNew',
                    controller ($location: ng.ILocationService, $filter: ng.IFilterService) {
                        const url = options.user.anonymous ? '/' : `/users/${$filter('encodeUsername')(options.user.username)}`;
                        $location.path(url);
                    }
                    // }).state('analytics', {
                    //     url: '/analytics?limit',
                    //     noindex: true,
                    //     controller: ($scope, $http, $stateParams, AnimatronProjects, HttpSvc, ProjectAugmenter, AnimatronPreviews) => {
                    //         const url = (options.isLocal ? 'http://localhost:8081' :
                    //                 ('https://' + (options.isProduction ? 'analytics.animatron.com' : 'analytics.animatron-test.com'))) +
                    //             '/analytics/projects';
                    //         $scope.animatron = new AnimatronProjects({});
                    //         $scope.animatron.nextPage = angular.noop;
                    //         $http.get(url).success((a: {count: number, _id: string}[]) =>
                    //             _.take(a, +$stateParams.limit)
                    //                 .forEach(p => HttpSvc('project', p._id).get().success((project: anm.Project) => {
                    //                     project.views = p.count;
                    //                     ProjectAugmenter(project);
                    //                     project.computedHeight = AnimatronPreviews.computeHeight(project.height, project.width, $scope.animatron.computedWidth);
                    //                     $scope.animatron.results.push(project);
                    //                 })
                    //             ));
                    //     },
                    //     templateUrl: require('projects.html'),
                    //     resolve: _.extend(setWrapper(''), projectsModules)
                })
                .state('studio-explore', {
                    url: '/studio/explore?confirmationSent&login&isNew&page',
                    template: '<explore-page></explore-page>',
                    reloadOnSearch: false,
                    resolve: _.extend(setWrapper('wrapper-explore'), setTitle('explore.title'), projectsModules, {})
                })
                .state('studio-search', {
                    url: '/studio/search?q&username&solr&myProjects&instant',
                    template: '<search-page></search-page>',
                    resolve: _.extend(setWrapper('wrapper-search'), setTitle(), loadModule(animatronSearchPage))
                })
                .state('tag', {
                    url: '/tags/:tag?super&user&page',
                    controller: ($scope: any, $rootScope: ng.IRootScopeService, $stateParams: any, AnimatronProjects: AnimatronProjectsFactory) => {
                        const tag_type = _.findKey(_.omit($stateParams, 'tag'), (param: string) => param === 'true');
                        $rootScope.setTitle('tags.title', $stateParams.tag);
                        $scope.AdSvc     = new AdSvc(false, $rootScope);
                        const adify      = $scope.AdSvc.adify.bind($scope.AdSvc);
                        $scope.animatron = new AnimatronProjects({tag: $stateParams.tag, tag_type}, false, '', adify);
                    },
                    templateUrl: require('projects.html'),
                    resolve: _.extend(setWrapper(''), setTitle(), projectsModules)
                })
                .state('studio-tutorial', {
                    url: '/studio/tutorial/:video',
                    reloadOnSearch: false,
                    params: {
                        video: {value: null, squash: true}
                    },
                    template: '<tutorials-page></tutorials-page>',
                    resolve: _.extend(setTitle('tutorial.title'), tutorialResolve)
                })
                .state('studio-education', {
                    url: '/studio/education',
                    template: '<education-page></education-page>',
                    resolve: _.extend(loadModule(animatronEdu), setWrapper('wrapper-long-head wrapper-edu'), setTitle('edu.title'))
                })
                .state('studio-education.week', {
                    url: '/:week',
                    controller($scope: any, $stateParams: any, $rootScope: ng.IRootScopeService) {
                        $scope.week.number = parseInt($stateParams.week.substring(4), 10);
                        $rootScope.setTitle(`edu.week${$scope.week.number}.title`);
                    },
                    templateUrl: ($stateParams: any) => require(`education/${$stateParams.week}.html`)
                })
                .state('about', {
                    url: '/about',
                    templateUrl: require('about.html'),
                    resolve: _.extend(loadModule(animatronAbout), setWrapper('wrapper-about wrapper-long-head'), setTitle('about.title'))
                })
                .state('company', {
                    url: '/company/{tab}',
                    params: {
                        tab: {
                            value: null,
                            squash: true
                        }
                    },
                    template: '<company />',
                    resolve: _.extend(
                        loadModule(animatronCompany),
                        setWrapper('wrapper-press'),
                        setTitle('press.title')
                    )
                })
                .state('wave_signup', {
                    url: '/wave-signup',
                    onEnter($location: ng.ILocationService) {$location.path('/wave/landing').replace()}
                })
                .state('wave-landing', {
                    url: '/wave/landing',
                    template: '<wave-landing></wave-landing>',
                    resolve: _.extend(loadModule(waveMain), setWrapper('wrapper-landing-WAVE'), setTitle('wv.landing.title'))
                })
                .state('contractors', {
                    url: '/contractors',
                    template: '<contractors></contractors>',
                    resolve: _.extend(loadModule(animatronContractors), setWrapper('wrapper-contractors'), setTitle('contractors.title'))
                })
                .state('root', {
                    url: '/?signup&login&redirect_to',
                    template: '<main-landing />',
                    resolve: _.extend(
                        loadModule(mainLanding()),
                        setWrapper('wrapper-landing-common'),
                        setTitle(''),
                        {
                            checkRedirect: /*@ngInject*/ ($location: ng.ILocationService) =>
                                redirect(!options.user.anonymous && $location.search().login, () =>
                                    $location.path('/login').replace()),
                            showModal: /*@ngInject*/($location: ng.ILocationService,
                                                     AuthenticationSvc: AuthenticationSvc,
                                                     LocalStorageSvc: LocalStorageSvc) => {
                                const redirect = $location.search().return_to || $location.search().login;
                                if (redirect) {
                                    AuthenticationSvc.loginModalShown = true;
                                    LocalStorageSvc.set('_animatron_redirect_onlogin', document.referrer);
                                }
                            }
                        })
                })
                .state('studio-landing', getLandingParams())
                .state('landingWithAnimation', _.extend(getLandingParams(), {
                    noindex: true,
                    url: '/landing/:animation?signup'
                }))
                .state('studio-landing-banner', { //isolate scope will break it
                    url: '/studio/html5-banner-maker',
                    templateUrl: require('landing/banner.html'),
                    resolve: _.extend(
                        loadModule(animatronBannerBottom),
                        setWrapper('wrapper-landing-common wrapper-landing-banner'),
                        setTitle('banner.title'))
                })
                .state('studio-special-annual-upgrade', {
                    url: '/studio/special-annual-upgrade',
                    template: `<special-annual-upgrade></special-annual-upgrade>`,
                    resolve: _.extend(
                        redirectForLogin(),
                        loadModule(animatronSpecialUpgrade),
                        setWrapper('wrapper-special-annual-upgrade'),
                        setTitle('special.annual.upgrade.title'))
                })
                .state('studio-landing-explainer', {
                    url: '/studio/explainer-video-maker',
                    templateUrl: require('landing/explainer.html'),
                    resolve: _.extend(
                        loadModule(animatronExplainerBottom),
                        setWrapper('wrapper-landing-common wrapper-landing-banner wrapper-landing-explainer'),
                        setTitle('explainer.title'))
                })
                .state('studio-landing-political', {
                    url: '/studio/political-cartoon-maker',
                    controllerAs: '$ctrl',
                    controller(this: any, $rootScope: ng.IRootScopeService, $scope: ng.IScope, $sce: ng.ISCEService) {
                        const baseUrl           = `https://videos.animatron.com/political_landing/political_cartoon${options.retina ? '_2x' : ''}`;
                        this.videoUrl           = $sce.trustAsResourceUrl(`${baseUrl}.mp4`);
                        this.imgUrl             = $sce.trustAsResourceUrl(`${baseUrl}.jpg`);
                        $rootScope.editorParams = '&guide=political';
                        $scope.$on('$destroy', () => $rootScope.editorParams = '');
                    },
                    templateUrl: require('landing/political-landing.html'),
                    resolve: _.extend(
                        setWrapper('wrapper-landing-common wrapper-landing-light wrapper-landing-political'),
                        setTitle('political.title')
                    )
                })
                .state('privacy', {
                    url: '/privacy',
                    templateUrl: require('privacy.html'),
                    resolve: _.extend({scrollTop: [() => window.scrollTo(0, 0)]},
                        loadModule(animatronPrivacy), setWrapper('wrapper-privacy'), setTitle('privacy.title'))
                })
                .state('oauthCallback', {
                    url: '/callback/:provider/:product?code',
                    noindex: true,
                    resolve: setTitle(),
                    onEnter: ($stateParams: any, $location: ng.ILocationService, OAuthCallbackSvc: OAuthCallbackSvc) =>
                        OAuthCallbackSvc.onCallback($stateParams, $location.hash())
                })
                .state('404', {
                    url: '/404',
                    noindex: true,
                    httpStatus: '404',
                    templateUrl: require('404.html'),
                    resolve: _.extend(setWrapper('wrapper-not-found'), setTitle('notfound.title'))
                })
                .state('logout', {
                    url: '/logout',
                    noindex: true,
                    onEnter(AuthenticationSvc: AuthenticationSvc) {
                        AuthenticationSvc.logoutAndGoRoot();
                    }
                })
                .state('terms-of-service', {
                    url: '/terms-of-service',
                    templateUrl: require('terms-of-service.html'),
                    resolve: _.extend({scrollTop: [() => window.scrollTo(0, 0)]},
                        loadModule(animatronTermsServices), setWrapper('wrapper-terms-of-service'), setTitle('terms.title'))
                })
                .state('project-analytics', {
                    url: '/project/{projectId}/analytics?rangeStart&rangeEnd',
                    noindex: true,
                    params: {project: null},
                    template: '<project-analytics></project-analytics>',
                    resolve: _.extend(loadModule(animatronProjectAnalytics), setWrapper('wrapper-analytics'), setTitle('analytics.title'))
                })
                .state('pages', {
                    url: '/pages',
                    noindex: true,
                    controller: ($state: ng.ui.IStateService) =>
                        document.querySelector('.main').innerHTML =
                            $state.get().map(s => `<a href="${$state.href(s.name, {})}">${s.name}</a><br>`).join('')
                })
                .state('project-likes', {
                    url: '/project/{projectId}/likes',
                    noindex: true,
                    params: {project: null},
                    template: `<a class="liker" style="text-align: center;"
                              ng-repeat="like in $ctrl.project.likes"
                              ui-sref="studio-user({username: (like.user.username | encodeUsername), user: like.user})"
                              ng-repeat="like in $ctrl.project.likes">
                                   <user-avatar user="like.user" size="45"></user-avatar>
                                   {{::like.user.displayName}}
                           </a>`,
                    controller: function (this: any, $stateParams: any, HttpSvc: HttpSvcFactory) {
                        HttpSvc('project', $stateParams.projectId)[options.user.anonymous ? 'get' : 'secureGet']()
                            .then((res: ng.IHttpPromiseCallbackArg<anm.Project>) => this.project = res.data);
                    },
                    controllerAs: '$ctrl',
                    resolve: _.extend(setWrapper(), setTitle())
                })
                .state('emotions-campaign', {
                    url: '/smmw16?gif&projectId&character&text&t2s&textEffect',
                    template: `<emotions-campaign></emotions-campaign>`,
                    resolve: _.extend(loadModule(animatronEmotions), setWrapper('emotions-campaign-wrapper'), setTitle('smmw16.title'))
                })
                .state('studio-account-downgrade', {
                    url: '/studio/account/downgrade?userid',
                    noindex: true,
                    onEnter($ocLazyLoad: oc.ILazyLoad, $injector: ng.auto.IInjectorService) {
                        animatronSettings().then(m => $ocLazyLoad.load(m)).then(() => {
                            const typeformSvc = $injector.get<TypeformSvc>('typeformSvc');
                            typeformSvc.cancelSubscription();
                        });
                    }
                })
                .state('studio-account-delete', {
                    url: '/studio/account/delete?userid',
                    noindex: true,
                    onEnter($ocLazyLoad: oc.ILazyLoad, $injector: ng.auto.IInjectorService) {
                        animatronSettings().then(m => $ocLazyLoad.load(m)).then(() => {
                            const typeformSvc = $injector.get<TypeformSvc>('typeformSvc');
                            typeformSvc.deleteAccount();
                        });
                    }
                })
                .state('contest-page', {
                    url: '/contest/:contestId',
                    template: `<contest-page></contest-page>`,
                    resolve: _.extend(loadModule(animatronContest), setWrapper('contest-wrapper'), setTitle())
                })
                .state('sharing', {
                    url: '/share/:tag',
                    noindex: true,
                    controllerAs: '$ctrl',
                    controller(this: any, $stateParams: any, AnimatronProjects: AnimatronProjectsFactory) {
                        this.animatron = new AnimatronProjects({
                            noCount: true,
                            limit: 5000,
                            tag: $stateParams.tag,
                            tag_type: 'SUPER',
                            previewWidth: 320
                        }, false, 'https://api.animatron.com');
                        this.animatron.nextPage();
                    },
                    templateUrl: require('project/publish/multi-share.html'),
                    resolve: _.extend(loadModule([animatronProjects, animatronPublish]), setWrapper(''), setTitle(''),
                        redirectResolve(() => !options.user.rolez.Admin, '/landing'))
                })
                .state('wave-pricing', {
                    url: '/wave/pricing',
                    template: '<wave-pricing></wave-pricing>',
                    controller: ['$scope', function ($scope: any) {
                        $scope.alwaysShowFaq = true;
                        window.scrollTo(0, 0);
                    }],
                    resolve: _.extend(
                        setWrapper('wrapper-pricing wrapper-pricing-WAVE'),
                        loadModule(wavePricing),
                        trackVisit('Pricing'),
                        setTitle('pricing.title')
                    )
                })
                .state('studio-pricing', {
                    url: '/studio/pricing',
                    templateUrl: require('studio/pricing.html'),
                    controller: ['$scope', function ($scope: any) {
                        $scope.alwaysShowFaq = true;
                        window.scrollTo(0, 0);
                    }],
                    resolve: _.extend(
                        trackVisit('Pricing'),
                        loadModule(animatronPricing),
                        setWrapper('wrapper-pricing'),
                        setTitle('pricing.title')
                    )
                });

            SMMWPages.forEach((page) => {
                const state = page.toLowerCase();

                $stateProvider.state(`wave-landing-smmw-${state}`, {
                    url: `/wave/SMExaminerReport${page}?${SMMWParams}`,
                    template: `<wave-landing-smmw view="'${page}'"></wave-landing-smmw>`,
                    resolve: _.extend(
                        setTitle(),
                        loadModule(waveLandingSMMW),
                        setWrapper('wrapper-landing-WAVE-SMMW'),
                        trackVisit('Landing', {Name: `SMExaminerReport${page}`})
                    )
                })
            });

            ['my-videos', 'my-templates'].forEach((state) => {
                $stateProvider.state(state, {
                    url: `/wave/${state}`,
                    template: `<wave-my-projects current-tab="${state}"/>`,
                    resolve: _.extend(
                        loadModule(waveMyProjects),
                        setWrapper('wrapper-wave-projects'),
                        redirectForLogin(null, '/wave/landing'),
                        setTitle(`wv.${state}.title`)
                    )
                })
            });

            ['affiliate-program', 'affiliate'].forEach((state) => {
                $stateProvider.state(state, {
                    url: `/${state}?${SMMWParams}`,
                    onEnter() {location.href = 'https://animatron.typeform.com/to/BQlCOH'}
                })
            });

            ['powtoon', 'goanimate', 'googlewebdesigner'].forEach((product) => {
                const state = `studio-${product}-landing-comparison`;
                const url   = `/studio/${product}-vs-animatron`;

                $stateProvider.state(state, {
                    url: url,
                    params: {product},
                    template: `<landing-comparison-page></landing-comparison-page>`,
                    resolve: _.extend(
                        loadModule(animatronComparisonBottom),
                        setWrapper('wrapper-landing-comparison wrapper-landing-common'),
                        setTitle())
                })
            });

            options.animatronProducts.forEach((product) => {
                const state = product.toLowerCase();

                ['profile', 'subscription', 'address', 'password', 'notification'].forEach(s => {
                    const isSubscription                  = s === 'subscription';
                    const subscriptionState: ng.ui.IState = {
                        url: `/subscription/:modal?period&plan&redeem&promo&special`,
                        params: {
                            modal: {
                                value: null,
                                squash: true
                            }
                        },
                        template: '<subscription-page></subscription-page>'
                    };

                    const defaultState = {
                        url: `/${s}`,
                        template: `<${s}></${s}>`
                    };

                    $stateProvider.state(`${state}-settings.${s}`, _.extend(
                        {noindex: true},
                        isSubscription ? subscriptionState : defaultState
                    ));
                });

                $stateProvider
                    .state(`${state}-activate-email`, {
                        noindex: true,
                        url: `/${state}/activate-email/:hash`,
                        onEnter($rootScope: ng.IRootScopeService,
                                $state: ng.ui.IStateService,
                                $stateParams: any,
                                HttpSvc: HttpSvcFactory,
                                AuthenticationSvc: AuthenticationSvc) {
                            HttpSvc('profile/confirm-email')
                                .securePost($stateParams.hash)
                                .then(r => r.data)
                                .then(res => {
                                    AuthenticationSvc
                                        .updateUser()
                                        .then(() => $state.go(`${state}-settings.profile`));

                                    if (Utils.isApiError(res)) {
                                        _.notification.showError(res.errorMessage);
                                    } else {
                                        _.notification.showSuccess($rootScope.t('profile.updated'));
                                    }
                                });
                        },
                        resolve: _.extend(
                            redirectForLogin(),
                            setWrapper(`wrapper-${product}`)
                        )
                    })
                    .state(`${state}-oauth-confirm`, {
                        noindex: true,
                        url: `/${state}/signup/oauth/confirm/:hash`,
                        onEnter($rootScope: ng.IRootScopeService,
                                $state: ng.ui.IStateService,
                                $stateParams: any,
                                HttpSvc: HttpSvcFactory,
                                AuthenticationSvc: AuthenticationSvc) {
                            HttpSvc('signup/oauth/confirm', $stateParams.hash)
                                .get()
                                .then(r => r.data)
                                .then(res => {
                                    AuthenticationSvc
                                        .updateUser()
                                        .then(() => $state.go(`${state}-settings.profile`));

                                    if (Utils.isApiError(res)) {
                                        _.notification.showError(res.errorMessage);
                                    } else {
                                        _.notification.showSuccess($rootScope.t('profile.updated'));
                                    }
                                });
                        },
                        resolve: _.extend(
                            redirectForLogin(),
                            setWrapper(`wrapper-${product}`)
                        )
                    })
                    .state(`${state}-login`, {
                        url: `/${state}/login`,
                        noindex: true,
                        template: '<login></login>',
                        resolve: _.extend(
                            setWrapper(`wrapper-${product}`),
                            setTitle('login.title'),
                            redirectResolve(() => !options.user.anonymous, (state === 'wave' ? 'wave/my-videos' : 'studio/explore'))
                        )
                    })
                    .state(`${state}-recovery`, {
                        url: `/${state}/recovery?email`,
                        template: '<recovery-page></recovery-page>',
                        resolve: _.extend(
                            loadModule(animatronRecovery),
                            setWrapper(`wrapper-activate`),
                            setTitle('recovery.request.title')
                        )
                    })
                    .state(`${state}-recovery-reset`, {
                        url: `/${state}/recovery/:hash`,
                        template: '<recovery-reset-page></recovery-reset-page>',
                        resolve: _.extend(
                            loadModule(animatronRecoveryReset),
                            setWrapper(`wrapper-activat`),
                            setTitle('recovery.reset.title')
                        )
                    })
                    .state(`${state}-settings`, {
                        url: `/${state}/settings`,
                        noindex: true,
                        controller: 'SettingsCtrl as settings',
                        templateUrl: require('settings/settings.html'),
                        resolve: _.extend(
                            redirectForLogin(),
                            loadModule(animatronSettings),
                            setWrapper(`wrapper-settings`),
                            setTitle()
                        )
                    })
                    .state(`${state}-project`, {
                        url: `/${state}/project/:projectId?staff&stopPlay`,
                        params: {project: null, stopPlay: null},
                        template: '<project-page></project-page>',
                        resolve: _.extend(
                            setWrapper(`standalone-project `),
                            setTitle(),
                            loadModule(animatronProject)
                        )
                    })
                    .state(`${state}-activate-oauth`, {
                        url: `/${state}/activate-oauth?product`,
                        noindex: true,
                        template: '<activate-oauth></activate-oauth>',
                        resolve: _.extend(
                            redirectResolve(() => !options.user.social),
                            loadModule(animatronActivate),
                            setWrapper(`wrapper-activate wrapper-long-head`),
                            setTitle('activate.title')
                        )
                    })
                    .state(`${state}-signup`, {
                        url: `/${state}/signup?email&product&sendRequest`,
                        templateUrl: require('signup/sign-up.html'),
                        resolve: _.extend(
                            loadModule(animatronSignup),
                            setWrapper(`wrapper-long-head`),
                            setTitle('signup.title')
                        )
                    })
                    .state(`${state}-activate`, {
                        url: `/${state}/activate/:hash`,
                        noindex: true,
                        template: '<activate-email></activate-email>',
                        resolve: _.extend(
                            loadModule(animatronActivate),
                            setWrapper(`wrapper-activate wrapper-long-head`),
                            setTitle('activate.title')
                        )
                    });
            });

            ['detailed-views', 'views-count', 'summarized'].forEach(state => {
                $stateProvider.state(`project-analytics.${state}`, {
                    url: `/${Strings.toCamelCase(state)}?period`,
                    noindex: true,
                    template: `<${state}-analytics-directive></${state}-analytics-directive>`
                });
            });

            ['most-plays', 'recently-added', 'staff-picks', 'contest-submissions', 'my-projects'].forEach(state => {
                $stateProvider.state(`studio-explore.${state}`, {
                        url: `/${state}?page&product`,
                        noindex: state === 'my-projects',
                        resolve: _.extend(setWrapper('wrapper-explore'))
                    }
                );
            });

            const landingGenerator = (list: Array<anm.AbstractLanding>, kind: anm.LandingKind, ...resolveParams: Object[]) => {
                list.forEach(page => {
                    $stateProvider.state(page.url, {
                        url: '/' + page.url,
                        controller(this: any) {this.data = Object.assign({}, page)},
                        controllerAs: '$ctrl',
                        template: `<${kind}-landing data="$ctrl.data"></${kind}-landing>`,
                        resolve: _.extend(
                            setTitle(page.title),
                            setWrapper(`wrapper-landing-common wrapper-landing-${kind}`),
                            ...resolveParams
                        )
                    });
                });
            };

            landingGenerator(LightLandings, 'light');
            landingGenerator(MediumLandings, 'medium', loadModule(animatronMediumLanding));
        })();
    }
}

angular.module('animatronApp.routes', ['ui.router'])
    .config(Routes);



// WEBPACK FOOTER //
// ./app/assets/javascripts/routes/routes.ts